import Vue from "vue";
import axios from "@/axios";
import Responses from "@/common/pagination/entities/responses";
import Restaurant from '@/models/Restaurant';
import BaseService from "./base-service";

class RestaurantsService extends BaseService {
  public async findOneAsync(id: number) {
    const res = await axios.get<Restaurant>(
      `restaurant/?api_key=${Vue.prototype.$apiKey}&uid=${id}`
    );
    return Responses.obj(res);
  }

  public async updateDisabledAsync(id: number, flag: number) {
    const res = await axios.put(`restaurant/?api_key=${Vue.prototype.$apiKey}&uid=${id}`, { disabled: flag });
    return res.status == 200;
  }
}

export default new RestaurantsService()